module.exports = __webpack_public_path__ + "img/background.f9af8df5.png";